import { useRoomContext } from '@/RoomContext'
import { RemoteDesktopControlEventTypes } from '@/pages/CollaboratePage/Types'
import useRoomActions from '@/services/useRoomActions'
import { useCallback } from 'react'
import { env } from './EnvironmentVariables'
import { VideoSource } from '@/pages/SessionPage/internal/shared/Video2'
import { useUserContext } from '@/UserContext'

export default function useScreenControlHostActions() {
    const [userState] = useUserContext()
    const [roomState, roomDispatch] = useRoomContext()

    const { sendMessageToPeer } = useRoomActions()

    const isControllingPeerDesktop = roomState.remoteDesktopControlStatus?.status === 'allowed'

    const onRemoteDesktopControlEvent = useCallback(
        (eventType: RemoteDesktopControlEventTypes, data: any) => {
            if (roomState.remoteDesktopControlStatus == null) {
                return
            }

            const { sessionId, username } = roomState.remoteDesktopControlStatus

            if (env.LOG_REMOTE_DESKTOP_CONTROL) {
                console.log(
                    `LOG_REMOTE_DESKTOP_CONTROL: emitting eventType=${eventType} ` +
                        `data=${JSON.stringify(data)} destination=${JSON.stringify({ username, sessionId })}`
                )
            }

            const type = `rdp:${eventType}`

            sendMessageToPeer(sessionId, {
                type: type,
                data: data,
            })
        },
        [roomState.remoteDesktopControlStatus, sendMessageToPeer]
    )

    const videoAreaClickHandler = (videoSource: VideoSource) => {
        if (videoSource.user !== 'me') {
            roomDispatch({
                type: 'update_room_context',
                value: {
                    isRemoteDesktopControlQueryPromptOpen: {
                        sessionId: videoSource.user.sessionId,
                        username: videoSource.user.username,
                    },
                },
            })
        }
    }

    const checkVideoScreenControllable = (videoSource: VideoSource) => {
        const allowScreenControl =
            videoSource.kind === 'screen' && videoSource.peer && userState.clientType !== 'listenonly'
        return allowScreenControl
    }

    return {
        isControllingPeerDesktop,
        checkVideoScreenControllable,
        onRemoteDesktopControlEvent,
        videoAreaClickHandler,
    }
}
